import { t } from "@travily/i18n";
import { Illustration } from "@ui/components/Illustration";
import { ListingCardAdapter, type ListingCardListing } from "@/components/ListingCard/ListingCardAdapter";
import { ListingSection } from "./ListingSection";

export interface ProductsProps {
  onAddProduct?: () => void;
  products: ListingCardListing[];
}

export function Products({ onAddProduct, products }: ProductsProps) {
  return (
    <ListingSection
      addLabel={t("components.views.shared.products.add_product")}
      addShortLabel={t("components.views.shared.products.add")}
      emptyDescription={t("components.views.shared.products.empty_description")}
      emptyIllustration={<Illustration name="products" />}
      emptyTitle={t("components.views.shared.products.empty_title")}
      items={products}
      onAdd={onAddProduct}
      renderCard={(product) => <ListingCardAdapter key={product.sqid} listing={product} />}
      title={t("components.views.shared.products.title")}
    />
  );
}
